import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessFailureModal from '../Components/Success_Failure_Modal';
import {getPOPurchaseOrders} from '../store/actions/supplierActions'
import {getVendorPODetailsForPOAcceptance} from '../store/actions/vendorActions'
import AuthHandler from '../Classes/AuthHandler';
import AuthHandlerInstance from '../Classes/AuthHandler'
import env from '../ENV';
import DropdownFlat from '../Components/DropdownFlat'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import swal from '@sweetalert/with-react';
import {connect} from 'react-redux'
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

function formatDate(date) {
    var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
    
    if (month.length < 2) 
    month = '0' + month;
    if (day.length < 2) 
    day = '0' + day;
    
    return [day, month, year].join('-');
  }
  
 
  class AdvancedReceivedPOAcceptance extends React.Component {

    constructor(props) {
        super(props);
        this.state={
         
        supplierName: "ABC Tech Inc.",
        select: true,
        open: false,
        selectAll: false,
        checked: [],
        opacity:"",
        multiCollapseIndex:"",
        Vendors : [],
        PONumbers:[],
        Projects:[],
        selectedVendor: "", selectedPo: "", selectedProject: "",
        // array:[
        //   {   value: 1, label: "element1"   },
        //   {   value: 2, label: "element2"    },
        //   {   value: 3, label: "element3"    },
        //   {   value: 4, label: "element4"    }],
        //   versiondata:[
        //     {   value: 1, label: "Version1"   },
        //     {   value: 2, label: "Version2"    },
        //     {   value: 2, label: "Version2"    }],
            
      }
      
      this.togglebutton = this.togglebutton.bind(this); 
      
      
    
    }
    action1() {
        this.setState({ action1: false });
    }

    handleSelectSupplier=(e)=>{
        let selectedData= e.target.value
        this.setState({selectedVendor: selectedData})
      }    
  
      handleSelectPoNo=(e)=>{
        let selectedData= e.target.value
        this.setState({selectedPo: selectedData})
      }    
  
      handleSelectProject=(e)=>{
        let selectedData= e.target.value
        this.setState({selectedProject: selectedData})
      }
    togglebutton=(Index)=> {  
        // const { open } = this.state;  
        // this.setState({  
        //     open: !open,  
        // }); 
        
        var multiCollapseIndex = this.state.multiCollapseIndex
    
        if(multiCollapseIndex!=Index || multiCollapseIndex==''){
          
          this.setState({multiCollapseIndex:Index})
      }
     
      
    } 
    

    componentDidMount(){
        var role = Object.keys(AuthHandlerInstance.getRoles())[0]
        
        var userId = AuthHandlerInstance.getUserID()
        if(role==5){
            this.props.getVendorPODetailsForPOAcceptance(userId)
        }
        else{
            this.props.getPOPurchaseOrders()
        }
        }  



    render()
    {
        var user = AuthHandlerInstance.getRoles()
        var array = []
        let Vendors = []
         {array.map((element,Index)=>
          Vendors.push(element.VendorName)
        )}

        let PoNo = []
        {array.map((element,Index)=>
            PoNo.push(element.POSAPId)
        )}

        let Projects = []
        {array.map((element,Index)=>
          Projects.push(element)
        )}
        console.log('######',array)


        // console.log('######',this.props.vendorReducer.getVendorPOsForPOAcceptance.recordset)

        try{
            if(this.props.vendorReducer && this.props.vendorReducer.getVendorPOsForPOAcceptance && this.props.vendorReducer.getVendorPOsForPOAcceptance.recordset && this.props.vendorReducer.getVendorPOsForPOAcceptance.recordset.length>0){
                this.props.vendorReducer.getVendorPOsForPOAcceptance.recordset.map(elem=>{
                    if(elem.POAcceptanceStatusId==7){
                        array.push(elem)
                    }
                })
            }
        }
        catch(error){

        }

        try {
            if(this.props.supplier && this.props.supplier.pos && this.props.supplier.pos.length>0){
                this.props.supplier.pos.map(element=>{
                    if(element.POAcceptanceStatusId==7){
                        array.push(element)
                    }
                })
            }
        } catch (error) {
            
        }

        if(this.props.supplier && 'pos_lists' in this.props.supplier && this.props.supplier.pos_lists && 'pos' in this.props.supplier.pos_lists && 'pos' in this.props.supplier.pos_lists){
            this.props.supplier.pos_lists.pos.map((element,index)=>{
                if(element.POAcceptanceDocumentID)
                    array.push(element)
            })
        }
        // console.log('@@@@@@',array)

        return(
            <div className="Container-fluid pageheight"  >
               
               <div className="Container-fluid p-4" style={{opacity:this.state.opacity}}>
                <div className="row pr-4" >
                <div className="col-md-3" style={{display:'flex'}} >   
                    <label className="col-md-4 pt-2" >Vendor:  </label>
                          <DropdownFlat defaultopt="Select Option"  data={Vendors} actions={this.handleSelectSupplier} keyObjName={"VendorName"}  valueObjName={"VendorName"} />
                          </div>
                    <div className="col-md-3" style={{display:'flex'}}>
                        <label className="col-md-4 pt-2" >Po No:  </label>
                          <DropdownFlat defaultopt="Select Option"  data={PoNo} actions={this.handleSelectPoNo} keyObjName={"POSAPId"} valueObjName={"POSAPId"} />
                      </div>

                      <div className="col-md-3" style={{display:'flex'}}>
                        <label className="col-md-4 mr-2 pt-2" >ProjectNo:  </label>
                          <DropdownFlat defaultopt="Select Option"  data={Projects} actions={this.handleSelectProject} keyObjName={"POSAPId"} valueObjName={"POSAPId"} />
                      </div>

                    
                    <div className="col pt-1  xs={last}">
                    <SearchBar placeholder="Search"  label="Search"  btnName=""  />
                    </div>
                </div>
                <div className="row-md-8 pr-4 sticky">
                    <div className="col wrap ">
                        <div className="row  headerbar sticky-inner">
                            
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Number</div>
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar">Vendor</div>
                            <div className="col-md-1 pt-2 pb-2 borderheaderbar ">Currency</div>
                            <div className="col-md-1 pt-2 pb-2 borderheaderbar ">PO Amount</div>
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">Created On</div>
                            <div className="col pt-2 pb-2 borderheaderbar d-none d-sm-block">Status</div>
                            <div className="col pt-2 pb-2 borderheaderbar d-none d-sm-block">Action</div>


                        </div>

                        {array.map((element,Index)=>
                        <div className={Index%2==0? 'row border ':'row  background '} 
                            onClick={()=>this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                           
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.POSAPId}</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.VendorName}</div>
                           <div className="col-md-1 pt-2 pb-2 borderheaderbar amount-text headeralign">{element.Currency}</div>
                           <div className="col-md-1 pt-2 pb-2 borderheaderbar amount-text headeralign">{numberWithCommas(element.POAmount.toFixed(2))}</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{dateFormater(element.POCreationDate)}</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{element.TrnStatusName}</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center d-none d-sm-block headeralign">
                           <Link  to ={{ pathname: '/PoAcceptanceTrail',state : { poId: element.PurchaseOrderId, poSAPId: element.POSAPId, PoAmount : element.POAmount } }}>
                                    <FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" />
                            </Link>
                           </div>
                           
                           
                          
                           
                           
                             
                         <div  style={{maxWidth:"1400px"}} className={Index==this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse` }> 
                         <form>
                                            <div></div>
                                            <div className="row">
                                                <div className="col-md-2">
                                                  <b>PO Delivery Date:</b>
                                                </div>
                                                <div className="col">
                                                {dateFormater(element.PODeliveryDate)}
                                                </div>
                                                
                                                <div className="col-md-2">
                                                 <b>PO Document: </b>
                                                </div>
                                                <div className="col">
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.PODocumentID + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon icon={"file-download"} color={'black'} title={element.PODocumentID == null || element.PODocumentID == 0 ? "Unavailable" : "Download"} size="lg" />
                                                </a>
                                                </div>
                                            </div>
                                            <br></br>
                                            <div className="row">
                                                <div className="col-md-2">
                                                  <b>Location:</b>
                                                </div>
                                                <div className="col">
                                                {element.Location}
                                                </div>
                                                
                                                <div className="col-md-2">
                                                 <b>PO Acceptance Document: </b>
                                                </div>
                                                <div className="col">
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.POAcceptanceDocumentID + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon icon={"file-download"} color={'black'} title={element.POAcceptanceDocumentID == null || element.POAcceptanceDocumentID == 0 ? "Unavailable" : "Download"} size="lg" />
                                                </a>
                                                </div>
                                            </div> 
                                        </form>
                         </div>
                        </div>
                        )}           

                    </div>
                </div>
            </div>
            </div>
            
        )
    }
}

const mapStateToProps  = (state) => ({supplier:state.supplier, vendorReducer:state.vendorReducer})
export default connect(mapStateToProps, {getPOPurchaseOrders, getVendorPODetailsForPOAcceptance })(AdvancedReceivedPOAcceptance)